import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const scaleIn = keyframes`
  from { opacity: 0; transform: translateY(12px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const StyledOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background-color: rgba(1, 37, 59, 0.6);
  animation: ${fadeIn} 0.2s ease;
`;

export const StyledDialog = styled.div<{
  $bg?: string | null;
  $color?: string | null;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 900px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  border-radius: var(--radius-md, 12px);
  background-color: ${({ $bg }) => $bg || "var(--color-secondary50)"};
  animation: ${scaleIn} 0.25s ease;

  @media only screen and (min-width: 768px) {
    flex-direction: row;
    align-items: stretch;
    min-height: 380px;
  }

  .popup__image {
    position: relative;
    width: 100%;
    min-height: 200px;
    background-color: var(--color-gray90);
    clip-path: polygon(100% 0, 100% 36%, 100% 66%, 65% 100%, 0 82%, 0 0);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    @media only screen and (min-width: 768px) {
      flex: 0 0 40%;
      align-self: stretch;
      min-height: 100%;
      clip-path: polygon(0 0, 62% 0, 100% 39%, 72% 100%, 0 100%, 0% 50%);
    }
  }

  .popup__content {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    padding: 24px;
    overflow-y: auto;

    @media only screen and (min-width: 768px) {
      padding: 64px 32px;
    }
  }

  .popup__title {
    font-family: var(--font-alternative);
    margin: 0;
    color: ${({ $color }) => $color || "var(--color-gray90)"};
    font-size: 26px;
    line-height: 1.4;
    font-weight: 700;
    text-align: left;
    margin-bottom: 16px;

    @media only screen and (min-width: 768px) {
      font-size: 32px;
    }
  }

  .popup__description {
    margin: 0;
    color: ${({ $color }) => $color || "var(--color-gray90)"};
    font-size: 16px;
    line-height: 1.7;
    text-align: left;
    margin-bottom: 16px;

    @media only screen and (min-width: 768px) {
      margin-bottom: 48px;
    }
  }

  .popup__action {
    margin-top: 8px;
  }
`;

export const CloseButton = styled.button<{ $color?: string | null }>`
  position: absolute;
  font-size: 32px;
  font-weight: 600;
  top: 12px;
  right: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${({ $color }) => $color || "var(--color-gray90)"};
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(1, 37, 59, 0.12);
  }
`;
